import ListAgroExporters from "@/views/customer/query/basic_containers/ListAgroExporters.vue";
import ListContainers from "@/views/customer/query/basic_containers/ListContainers.vue";
import ShowContainer from "@/views/customer/query/basic_containers/ShowContainer.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "cus",
  role: "query",
  permission: "basic_containers",
});

export default [
  {
    path: "/cus/:customer_id/query/basic_containers/list_agro_exporters",
    name: routeName(""),
    component: ListAgroExporters,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/query/basic_containers/:agro_exporter_id/list_containers",
    name: routeName("list_containers"),
    component: ListContainers,
    props: true,
    meta: META
  },
  {
    path: "/cus/:customer_id/query/basic_containers/:agro_exporter_id/show_container/:container_id",
    name: routeName("show_container"),
    component: ShowContainer,
    props: true,
    meta: META
  }
];
